import React, { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  IconButton,
} from "@mui/material";
import moment from "moment";
import PageLoader from "examples/ReuseFunctions/PageLoader";
import axios from "../../api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "components/AlertMessages/SnackbarContext";
import { AxiosError } from "axios";
import { JSX } from "react/jsx-runtime";
interface Asset {
  asset_service_id: string;
  asset_name: string;
  subscription_type: string;
  start_date: string | Date;
  end_date: string | Date;
  division_name: string;
  asset_type_id?: number | string;
}

interface Subscription {
  subscription_type_name: string;
  created_at: string | Date;
  end_date: string | Date;
  is_active: boolean;
  subscription_id: number;
}

interface FreeService {
  map(arg0: (item: any, index: any) => JSX.Element): React.ReactNode;
  length: number;
}
const CustomerViewSubscription: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { fetchError } = useSnackbar();
  const navigate = useNavigate();
  const [assetData, setAssetData] = useState<Asset | null>(null);
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [freeServices, setFreeServices] = useState<FreeService>([]);
  const [loading, setLoading] = useState(true);
  const fetchData = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const [assetResponse, subscriptionResponse, freeServiceResponse] =
        await Promise.all([
          axios.get(`/subscription/${id}`),
          axios.get(`/subscription/assets/${id}`),
          axios.get(`/subscription/${id}/free-services`),
        ]);

      setAssetData(assetResponse?.data);
      setSubscriptions(subscriptionResponse?.data?.list || []);
      setFreeServices(freeServiceResponse?.data?.free_services || []);
    } catch (error) {
      navigate("/customer/assets-list");
      if (error instanceof AxiosError && error.response) {
        fetchError(error.response?.data?.error || error.message);
      }
    } finally {
      setLoading(false);
    }
  }, [id, fetchError, navigate]);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, fetchData]);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        className="view-ticket"
        style={{
          padding: "24px",
          width: "100%",
          borderRadius: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"center"}
          className="view-ticket-title"
        >
          <IconButton className="back-btn">
            <ArrowBackIcon
              onClick={() => navigate("/customer-subscriptions-list")}
            />
          </IconButton>
          <Typography variant="h5" gutterBottom>
            Subscription Details
          </Typography>
        </Grid>

        <Grid container className="view-ticket-details">
          <Grid item xs={4} sm={4} md={2} sx={{ my: 1 }}>
            <Typography variant="h6">
              <Box display="flex" justifyContent="left">
                <span>Asset Id</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={4} sx={{ my: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "normal" }}>
              <Box display="flex" justifyContent="flex-start">
                <span>: {assetData?.asset_service_id}</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={2} sx={{ my: 1 }}>
            <Typography variant="h6">
              <Box display="flex" justifyContent="left">
                <span>Brand Name</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={4} sx={{ my: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "normal" }}>
              <Box display="flex" justifyContent="flex-start">
                <span>: {assetData?.asset_name}</span>
              </Box>
            </Typography>
          </Grid>
          {assetData?.division_name != null && (
            <>
              <Grid item xs={4} sm={4} md={2} sx={{ my: 1 }}>
                <Typography variant="h6">
                  <Box display="flex" justifyContent="left">
                    <span>Division</span>
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={8} sm={8} md={4} sx={{ my: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "normal" }}>
                  <Box display="flex" justifyContent="flex-start">
                    <span>: {assetData?.division_name}</span>
                  </Box>
                </Typography>
              </Grid>
            </>
          )}
          <Grid item xs={4} sm={4} md={2} sx={{ my: 1 }}>
            <Typography variant="h6">
              <Box display="flex" justifyContent="left">
                <span>Subscription Type</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={4} sx={{ my: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "normal" }}>
              <Box display="flex" justifyContent="flex-start">
                <span>: {assetData?.subscription_type}</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={2} sx={{ my: 1 }}>
            <Typography variant="h6">
              <Box display="flex" justifyContent="left">
                <span>Subscription Start Date</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={4} sx={{ my: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "normal" }}>
              <Box display="flex" justifyContent="flex-start">
                <span>
                  :{" "}
                  {assetData?.start_date
                    ? moment(assetData?.start_date).format("MMM D, YYYY")
                    : ""}
                </span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4} md={2} sx={{ my: 1 }}>
            <Typography variant="h6">
              <Box display="flex" justifyContent="left">
                <span>Subscription End Date</span>
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={8} sm={8} md={4} sx={{ my: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "normal" }}>
              <Box display="flex" justifyContent="flex-start">
                <span>
                  :{" "}
                  {assetData?.end_date
                    ? moment(assetData?.end_date).format("MMM D, YYYY")
                    : ""}
                </span>
              </Box>
            </Typography>
          </Grid>
        </Grid>

        {/* Subscription History Section */}
        {subscriptions && subscriptions.length > 0 && (
          <>
            <Divider sx={{ height: 2, backgroundColor: "blue", my: 2 }} />
            <Typography variant="h5" gutterBottom>
              Subscription History
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ display: "table-row-group" }}>
                  <TableRow>
                    <TableCell>Subscription Type</TableCell>
                    <TableCell>Created Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subscriptions.map((data, index) => (
                    <TableRow key={data.subscription_id}>
                      <TableCell>
                        <Typography variant="h6" sx={{ fontWeight: "normal" }}>
                          <Box>
                            <span>{String(data?.subscription_type_name)}</span>
                          </Box>
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="h6" sx={{ fontWeight: "normal" }}>
                          <Box>
                            <span>
                              {moment(data?.created_at).format("MMM D, YYYY")}
                            </span>
                          </Box>
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="h6" sx={{ fontWeight: "normal" }}>
                          <Box>
                            <span>
                              {moment(data?.end_date).format("MMM D, YYYY")}
                            </span>
                          </Box>
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="h6" sx={{ fontWeight: "normal" }}>
                          <Box>
                            <span>
                              {data?.is_active ? "Active" : "In-Active"}
                            </span>
                          </Box>
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        {/* Status Tracker Timeline */}
        <Divider sx={{ height: 2, backgroundColor: "blue", my: 3 }} />

        <Typography variant="h5" gutterBottom>
          Service Status Timeline
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", ml: 2 }}>
          {/* Start Date */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: "green",
                mr: 2,
              }}
            ></Box>
            <Typography variant="h6">
              Start Date: {moment(assetData?.start_date).format("MMM D, YYYY")}
            </Typography>
          </Box>

          {/* Vertical Line */}
          <Box sx={{ borderLeft: "2px solid grey", height: 40, ml: 0.8 }}></Box>

          {/* Free Services Loop */}
          {freeServices.map((item, index) => {
            console.log("Free Service Item:", item);
            let backgroundColor = "blue";

            if (item.ticket_status === 6) {
              backgroundColor = "green";
            } else if (item.status === "scheduled") {
              backgroundColor = "orange";
            }

            return (
              <React.Fragment key={item.id}>
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      borderRadius: "50%",
                      backgroundColor,
                      mr: 2,
                    }}
                  ></Box>
                  <Typography variant="h6">
                    {item.ticket_status === 6 ? (
                      <>
                        Free Service #{index + 1} &mdash;{" "}
                        <Typography
                          component="span"
                          sx={{ color: "green", fontWeight: "bold" }}
                        >
                          Completed
                        </Typography>{" "}
                        ({moment(item.ticket_closed_at).format("MMM D, YYYY")})
                      </>
                    ) : (
                      <>
                        Free Service #{index + 1} &mdash; {item.status} (
                        {moment(item.scheduled_at).format("MMM D, YYYY")})
                      </>
                    )}
                  </Typography>
                </Box>

                {/* Vertical line after each node */}
                {index < freeServices.length && (
                  <Box
                    sx={{ borderLeft: "2px solid grey", height: 40, ml: 0.8 }}
                  ></Box>
                )}
              </React.Fragment>
            );
          })}

          {/* End Date */}
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Box
              sx={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: "red",
                mr: 2,
              }}
            ></Box>
            <Typography variant="h6">
              End Date: {moment(assetData?.end_date).format("MMM D, YYYY")}
            </Typography>
          </Box>
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default CustomerViewSubscription;
